import React from "react";
import Modal from "react-modal";
import "../show-document/show-doc.scss";
import { OutTable, ExcelRenderer } from "react-excel-renderer";

class ShowResidualPdfModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cols: [],
            rows: [],
        };
    }

    componentDidMount() {
        this.urltoFile(
            "data:application/pdf;base64," + this.props.file.encFile,
            "hello.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ).then((file) => {
            ExcelRenderer(file, (err, resp) => {
                if (err) {
                } else {
                    this.setState({
                        cols: resp.cols,
                        rows: resp.rows,
                    });
                }
            });
        });
    }

    urltoFile(url, filename, mimeType) {
        return fetch(url)
            .then(function (res) {
                return res.arrayBuffer();
            })
            .then(function (buf) {
                return new File([buf], filename, { type: mimeType });
            });
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isOpen} className="doc-modal">
                    <div className="header dFlex">
                        <h5>
                            File :{" "}
                            {this.props.file != null && this.props.file.file}
                        </h5>
                        {this.props.file != null && (
                            <div className="opn-btn">
                                <button
                                    className="close-modal"
                                    onClick={() => this.props.close()}
                                >
                                    {" "}
                                    <i className="fa fa-times pointer"></i>
                                </button>
                            </div>
                        )}
                    </div>
                    {this.props.file == null && <p className="loader"></p>}
                    {this.props.file != null && (
                        <div className="con-tainer">
                            {this.props.fileType == "pdf" ||
                            this.props.fileType == "PDF" ? (
                                //   <embed src={"data:application/pdf;base64," + this.props.file.encFile} className="file-src" />
                                <OutTable
                                    data={this.state.rows}
                                    columns={this.state.cols}
                                    tableClassName="ExcelTable2007"
                                    tableHeaderRowClass="heading"
                                />
                            ) : (
                                <div className="msg-container">
                                    {this.props.file != null && (
                                        <a
                                            className="download-link"
                                            href={
                                                "/org-contract/download/" +
                                                this.props.file.id
                                            }
                                        >
                                            <h4>
                                                Preview not available please
                                                download.
                                            </h4>
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </Modal>
            </div>
        );
    }
}

export default ShowResidualPdfModal;
